import { useContext } from "react";
import { ClipboardContext } from "./ClipboardContext";

export function useClipboardContext() {
    return useContext(ClipboardContext);
}
